import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=7acaec3c&scoped=true&"
import script from "./ResourceItem.vue?vue&type=script&lang=js&"
export * from "./ResourceItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourceItem.vue?vue&type=style&index=0&id=7acaec3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acaec3c",
  null
  
)

export default component.exports